import React from 'react';
import { STRAVA_CONFIG } from '../config';

const StravaAuth = () => {
    const handleLogin = () => {
        const authUrl = `${STRAVA_CONFIG.authUrl}?client_id=${STRAVA_CONFIG.clientId}&response_type=code&redirect_uri=${encodeURIComponent(STRAVA_CONFIG.redirectUri)}&scope=${encodeURIComponent(STRAVA_CONFIG.scope)}`;
        window.location.href = authUrl;
    };

    return (
        <div className="strava-auth">
            <button 
                onClick={handleLogin}
                className="strava-login-button"
                style={{
                    backgroundColor: '#FC4C02',
                    color: 'white',
                    border: 'none',
                    padding: '10px 20px',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontSize: '16px',
                    fontWeight: 'bold'
                }}
            >
                Connect with Strava
            </button>
        </div>
    );
};

export default StravaAuth; 